export * from './ConversationSummary'
export * from './ConversationsQueryParamBuilder'
export * from './ConversationsTable'
export * from './ConversationHeader'
export * from './MessageBoard'
export * from './AiButton'
export * from './PublishRequiredCard'
export * from './PublishWarningDialog'

export const sentimentStyles: Record<string, string> = {
  very_positive: 'text-green-12 bg-green-4 ',
  positive: 'text-lime-12 bg-lime-4',
  neutral: 'text-gray-12 bg-gray-4',
  negative: 'text-orange-12 bg-orange-4',
  very_negative: 'text-red-12 bg-red-4',
  pending: 'text-gray-12 bg-gray-3',
}

export const sentimentLabels: Record<string, string> = {
  very_positive: 'Very Positive',
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
  very_negative: 'Very Negative',
  pending: 'Pending',
}
